import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import { Editor } from 'react-draft-wysiwyg';
import styled from 'styled-components';
import styles from '../shared/styles';
import { RowDivision, DivisionLabel } from '../shared/styled-components';
import { ActionButton, DraftEditorWrapper, ToggleWrapper, ToggleLabel } from '../../../../styles/styled';

const Subscription = props => {
  const {
    signupEmailLabel,
    signupEmailValue,
    onChangeSignupEmail,
    onResetToDefaultEmail,
    enableSignupEmail,
    onChangeSignupEmailToggle,
  } = props;

  const renderToggleBtn = () => {
    const toggleText = enableSignupEmail
      ? 'Send signup confirmation message'
      : "Don't send signup confirmation message";

    return (
      <ToggleWrapper>
        <Toggle
          className="toggle-green"
          aria-labelledby="toggle subscription"
          checked={enableSignupEmail}
          onChange={() => onChangeSignupEmailToggle(!enableSignupEmail)}
        />
        <ToggleLabel className="text-large">{toggleText}</ToggleLabel>
      </ToggleWrapper>
    );
  };

  const renderResetToDefaultEmailButton = () => {
    return (
      <SetupButton className="btn" onClick={onResetToDefaultEmail}>
        Reset to default email
      </SetupButton>
    );
  };

  return (
    <RowDivision className="row">
      <div id="subscription-email" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>{signupEmailLabel}</DivisionLabel>
        <div className="margin-bottom-10px">
          <DraftEditorWrapper>
            <Editor
              editorState={signupEmailValue}
              editorStyle={styles.editorStyle}
              wrapperStyle={styles.wrapperStyle}
              onEditorStateChange={onChangeSignupEmail}
              stripPastedStyles={true}
            />
          </DraftEditorWrapper>
        </div>
        {renderToggleBtn()}
        {renderResetToDefaultEmailButton()}
      </div>
    </RowDivision>
  );
};

const SetupButton = styled(ActionButton)`
  margin: 10px 0 0;
  background-color: #369563;
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 1.6rem;
  font-weight: normal;
`;

Subscription.propTypes = {
  signupEmailLabel: PropTypes.string,
  signupEmailValue: PropTypes.object,
  onChangeSignupEmail: PropTypes.func,
  onResetToDefaultEmail: PropTypes.func,
  enableSignupEmail: PropTypes.bool,
  signupEmailToggleLabel: PropTypes.string,
  onChangeSignupEmailToggle: PropTypes.func,
};

Subscription.defaultProps = {
  signupEmailLabel: 'Signup Confirmation Message',
  signupEmailValue: {},
  onChangeSignupEmail: () => {},
  onResetToDefaultEmail: () => {},
  enableSignupEmail: true,
  signupEmailToggleLabels: [
    'Send signup confirmation message',
    "Don't send signup confirmation message",
  ],
  onChangeSignupEmailToggle: () => {},
};

export default Subscription;
